module.exports = __webpack_public_path__ + "img/bf0d2dc.svg";